import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    jobBoards: {
      selectIds: [],
      filters: {}
    }
  },
  mutations: {
    SET_JOBBOARD_SELECT_IDS (store, ids) {
      store.jobBoards.selectIds = ids
    },
    SET_JOBBOARD_FILTERS (store, filters) {
      store.jobBoards.filters = filters
    }
  },
  getters: {
    getJobBoards: (store, getters) => {
      return store.jobBoards.selectIds.map((id) => {
        return getters['entities/jobBoards/find'](id)
      })
    },
    getJobBoardsFilters: (store, getters) => {
      return store.jobBoards.filters
    }
  },
  actions: {
    /*
    selectJobBoards
    */
    selectJobBoards ({commit, dispatch, getters, state}, filters) {
      return dispatch('getJobBoards', filters)
      .then((response) => {
        commit('SET_JOBBOARD_FILTERS', filters)
        commit('SET_JOBBOARD_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectJobBoards
    */
    refreshSelectJobBoards ({commit, dispatch, getters, state}) {
      return dispatch('selectJobBoards', getters.getJobBoardsFilters)
    },
    /*
    getJobBoards
    */
    getJobBoards ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/job-boards`, {params: filters})
      .then((response) => {
        return dispatch('entities/jobBoards/insert', {
          data: response.data
        })
        .then((result) => {
          return result.jobBoards || []
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/JobBoard.js